import { render } from "./MouseCurson.vue?vue&type=template&id=1c43c14e"
import script from "./MouseCurson.vue?vue&type=script&lang=js"
export * from "./MouseCurson.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__